import React, { useEffect, useRef, useState } from "react";
import "./../login/Login.scss";
import "./TwoFactorAuthentication.scss"

import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import Input from "../../components/ui/inputs/input/Input";
import Buttons from "../../components/ui/button/Buttons";
import { useAuthVerifyOTPMutation } from "../../app/services/authAPI";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createCookie, removeCookie } from "../../utils/Cookies/CookieHandler";
import ToastService from "../../services/toastService/ToastService";
import { authentication } from "../../app/slice/authSlice";
import SwalAlert from "../../services/swalService/SwalService";

const TwoFactorAuthentication = () => {

  const dispath = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef();

  const { error } = SwalAlert();

  let rememberMe = location?.state?.rememberMe;
  let userEmail = location?.state?.user?.emailAddress;
  let userID = location?.state?.user?.userID;

  const [actualOtp, setActualOtp] = useState("");

  const [authVerifyOTP, {
    isLoading: isAuthVerifyOTPAdding,
    isSuccess: isAuthVerifyOTPAdded,
    data: authVerifyOTPData,
  },] = useAuthVerifyOTPMutation();

  const handleChange = (e) => {
    let value = e.target.value;
    setActualOtp(value)
  }

  const handleSubmitClick = () => {
    let requestOtp = actualOtp
    if (requestOtp && requestOtp.length === 6) {
      const req = {
        Otp: requestOtp,
        EmailAddress: userEmail,
        userID: userID,
      };
      authVerifyOTP(req);
    }
  };

  useEffect(() => {
    if (isAuthVerifyOTPAdded && authVerifyOTPData) {
      if (authVerifyOTPData?.isAuthenticated) {
        dispath(authentication(authVerifyOTPData));

        if (rememberMe) {
          const rememberMeCookie = {
            cookieName: "rememberMe",
            cookieValue: userEmail,
            path: "/",
            expirationTime: 7 * 24,
          };
          createCookie(rememberMeCookie);
        } else {
          removeCookie("rememberMe");
        }
        if (authVerifyOTPData?.user?.passwordResetRequired) {
          navigate(`/ResetPassword`);
        } else {
          navigate(`/dashboard`);
        }
        ToastService.success("OTP Verified Successfully!");
      } else {
        error("", "Invalid OTP or OTP expired. Login again").then(
          (confirmed) => {
            if (confirmed) {
              removeCookie("rememberMe");
              navigate(`/login`);
            }
          }
        );
        removeCookie("rememberMe");
        navigate(`/login`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthVerifyOTPAdded, authVerifyOTPData]);

  return (
    <div className="login-page two-factor-authentication">
      <div className="logo-sec">
        <Image imagePath={AppIcons.BBCustomLogo} altText="Login Vector" />


        <div className="login-form">
          <div className="form">
            <div className="center-icon">
              <Image imagePath={AppIcons.TwoFactorLogo} altText="Login Vector" />
            </div>
            <div className="title-sec">
              <h1 className="title">Two-Factor Authentication</h1>
              <p className="welcome-txt">
                Please Enter Authentication Code
              </p>
            </div>

            <div className="field mb-4">
              <Input
                type="password"
                className="task-title input-field"
                placeholder="Authentication Code"
                onChange={handleChange}
                maxLength={6}
                ref={inputRef}
              />
            </div>
            <div className="btn-sec">
              <Buttons
                buttonTypeClassName="login-btn"
                titleText="SUBMIT"
                buttonText="SUBMIT"
                onClick={handleSubmitClick}
                isLoading={isAuthVerifyOTPAdding}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorAuthentication;
